import classNames from 'classnames';

import { Drawer, DrawerProps } from '@app/components/containers/content/drawer';

import styles from './styles.scss';

export const CartDrawer = ({ className, ...props }: DrawerProps) =>
    Drawer({ ...props, className: classNames(styles.cartDrawer, className) });
